//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as ActivityActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- List books ----------------


//  -- List books ----------------
export const handleInvokeFeedbackForm = (feedback) => async(dispatch) => {
    await dispatch(ActivityActions.invokeFeedback());
}
export const handleRevokeFeedbackForm = (feedback) => async(dispatch) => {
    await dispatch(ActivityActions.revokeFeedback());

}
export const handleCreateFeedback = (feedback,cb) => async(dispatch) => {
    await dispatch(ActivityActions.createFeedback(feedback));
    try {
        const feedbackResonce = await apis.post('feedbackRDS', '/feedback', {
            body: feedback
        });
        cb(feedbackResonce)
    await dispatch(ActivityActions.feedbackSuccess(feedbackResonce));
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'creating feedback',
                error,
                module: 'FEEDBACK',
                operation: 'CREATE_FEEDBACK'
            });
         }
        console.log(error);
        cb();
    }
   
}

export const handleListFeedback = (params = {}) => async(dispatch) => {
    try {
        const { offset = 0, limit = 100, search = '', status = '', startDate = '', endDate = '', sortBy = 'createdAt', sortOrder = 'desc' } = params;
        const queryParams = new URLSearchParams({
            offset: offset.toString(),
            limit: limit.toString(),
            sortBy,
            sortOrder,
            ...(search && { search }),
            ...(status && { status }),
            ...(startDate && { startDate }),
            ...(endDate && { endDate })
        });
        
        const feedbackResponse = await apis.get('feedbackRDS', `/feedback?${queryParams.toString()}`);
        return feedbackResponse;
    } catch (error) {
        if(error && error.message !== "Network Error"){
            logToSentry({
                message: 'listing feedback',
                error,
                module: 'FEEDBACK',
                operation: 'LIST_FEEDBACK'
            });
        }
        console.log(error);
        throw error;
    }
}

export const handleUpdateFeedback = async (id, data) => {
    try {
        const response = await apis.put('feedbackRDS', `/feedback/${id}`, {
            body: data
        });
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error updating feedback',
                error,
                module: 'FEEDBACK',
                operation: 'UPDATE_FEEDBACK'
            });
        }
        throw error;
    }
};

export const handleCreateJiraTicket = async (id) => {
    try {
        const response = await apis.post('feedbackRDS', `/feedback/${id}/create-jira-ticket`, {});
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error creating Jira ticket',
                error,
                module: 'FEEDBACK',
                operation: 'CREATE_JIRA_TICKET'
            });
        }
        throw error;
    }
};